import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {when} from 'lit/directives/when.js';

import {connect} from 'pwa-helpers';
import {live} from 'lit/directives/live.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {selectSolarSelfSufficiency, selectSolarVersion} from '../../solarSelectors';
import {staggeredReveal} from '../../../css/styleSets';
import {attributeWidget} from '../../../css/attributeWidget';
import {setSolarSelfSufficiency} from '../../solarSlice';


@customElement('self-sufficiency')
export class SelfSufficiency extends connect(store)(LitElement) {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {
			}


			.seasons {
				display: flex;
				flex-direction: row;
				gap: 10px;
			}

			.season {
				display: flex;
				flex-direction: column;
				gap: 5px;
				flex-grow: 1;
			}

			.label {
				font: var(--font-widget-title);
				color: var(--color-widget-border);
			}

			input {
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: var(--color-background-widget);

				height: 40px;
				box-sizing: border-box;
				transition: background-color 0.4s, color 0.4s;
				padding: 0.5em 1em;
				line-height: 120%;
				margin: 0;
				border: 1px solid var(--color-widget-border);
				width: 100%;
				text-align: left;
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.icon {
				width: 11px;
				height: 11px;
				padding: 5px;
				display: inline-block;
			}

			.icon svg {
				display: block;
				fill: currentColor
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}


			.info {
				padding: 0.5rem;
				font-family: var(--font-family-light);
				color: var(--color-text-widget);
				font-size: 12px;
				opacity: 0.7;
			}

			@media (max-width: 768px) {
				input {
					width: 50vw;
				}
			}

		`];

	@property({type: Object})
	solarSelfSufficiency = {};

	constructor() {
		super();
		this.hasCoefficients = false;
		store.subscribe(() => this.requestUpdate());
	}

	connectedCallback() {
		super.connectedCallback();
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.debug = state.status.debug;
		this.solarSelfSufficiency = selectSolarSelfSufficiency(state);
		this.solarVersion = selectSolarVersion(state);
		this.loggedIn = state.userProfile.data.loggedIn;
	}


	onChange(value, season) {
		// clone this.solarSelfSufficiency
		const newSelfSufficiency = JSON.parse(JSON.stringify(this.solarSelfSufficiency));
		if (!isNaN(parseInt(value, 10))) {
			if (season === 'all') {
				// if basic, set all seasons to the same value
				newSelfSufficiency[this.solarVersion].summer = parseInt(value, 10);
				newSelfSufficiency[this.solarVersion].spring = parseInt(value, 10);
				newSelfSufficiency[this.solarVersion].winter = parseInt(value, 10);
				store.dispatch(setSolarSelfSufficiency({selfSufficiency: newSelfSufficiency}));
			} else {
				newSelfSufficiency[this.solarVersion][season] = parseInt(value, 10);
				store.dispatch(setSolarSelfSufficiency({selfSufficiency: newSelfSufficiency}));
			}
		}
	}

	render() {
		if (!this.loggedIn) return null;

		//console.log('render self-sufficiency', this.solarSelfSufficiency);
		return html`
			<div>
				<div class="title">
					${msg('Self Sufficiency Days')} (${this.solarVersion})
				</div>
				<div class="seasons">
					${when(this.solarVersion === 'AetoBasic',
						() => html`
							<div class="season">
								<div class="label">${msg('All Seasens')}</div>
								<input id='summer' class="numericInput" type="number" step="1" min="1" max="30"
									   .value="${live(this.solarSelfSufficiency[this.solarVersion].summer)}"
									   @change="${(e) => this.onChange(e.target.value, 'all')}">
							</div>
						`, () => html`
							<div class="season">
								<div class="label">${msg('summer')}</div>
								<input id='summer' class="numericInput" type="number" step="1" min="1" max="30"
									   .value="${live(this.solarSelfSufficiency[this.solarVersion].summer)}"
									   @change="${(e) => this.onChange(e.target.value, 'summer')}">
							</div>
							<div class="season">
								<div class="label">${msg('spring/fall')}</div>
								<input id='spring' class="numericInput" type="number" step="1" min="1" max="30"
									   .value="${live(this.solarSelfSufficiency[this.solarVersion].spring)}"
									   @change="${(e) => this.onChange(e.target.value, 'spring')}">
							</div>
							<div class="season">
								<div class="label">${msg('winter')}</div>
								<input id='winter' class="numericInput" type="number" step="1" min="1" max="30"
									   .value="${live(this.solarSelfSufficiency[this.solarVersion].winter)}"
									   @change="${(e) => this.onChange(e.target.value, 'winter')}">
							</div>
						`)}


				</div>
			</div>

		`;
	}
}
